import React, { useMemo } from 'react';
import { Chart } from 'primereact/chart';
import { ProgressSpinner } from 'primereact/progressspinner';

const ChartInner = ({ loading, error, hasData,isEmpty, children }) => {
    if (loading) return (
        <div className="chart-empty">
            <ProgressSpinner style={{ width: '40px', height: '40px' }} strokeWidth="4" />
            <p>Loading...</p>
        </div>
    );
    if (error) return (
        <div className="chart-empty chart-empty--error">
            <i className="pi pi-exclamation-circle" />
            <p>Failed to load data</p>
        </div>
    );
    if (!hasData) return (
        <div className="chart-empty">
            <i className="pi pi-chart-pie" />
            <p>Search the DC to load data</p>
        </div>
    );
    if (isEmpty) return (
        <div className="chart-empty">
            <i className="pi pi-info-circle" />
            <p>No data found</p>
        </div>
    );
    return children;
};

const LatencyDistributionChart = ({ deviceLatency, loading, error }) => {
    const buckets   = deviceLatency?.buckets || [];
    const lt        = buckets.find(b => b.key === 'LT_THRESHOLD');
    const gte       = buckets.find(b => b.key === 'GTE_THRESHOLD');
    const threshold = deviceLatency?.thresholdMs ?? 90;

    const { data, options } = useMemo(() => ({
        data: {
            labels: [`< ${threshold} ms`, `≥ ${threshold} ms`],
            datasets: [{
                data: [lt?.count ?? 0, gte?.count ?? 0],
                backgroundColor: ['#90CAF9', '#CFD8DC'],
                hoverBackgroundColor: ['#64B5F6', '#B0BEC5']
            }]
        },
        options: {
            plugins: {
                legend: { position: 'bottom', labels: { boxWidth: 12 } },
                tooltip: {
                    callbacks: {
                        label: (ctx) => {
                            const key = ctx.dataIndex === 0 ? 'LT_THRESHOLD' : 'GTE_THRESHOLD';
                            const bucket = buckets.find(b => b.key === key);
                            return ` ${ctx.label}: ${ctx.raw} devices (${bucket?.percentage ?? 0}%)`;
                        }
                    }
                }
            },
            responsive: true,
            maintainAspectRatio: false
        }
    }), [deviceLatency]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="chart-card">
            <h5 className="chart-title">Device Latency</h5>
            <ChartInner
                loading={loading}
                error={error}
                hasData={!!deviceLatency}
                isEmpty={(!lt && !gte) || (lt?.count === 0 && gte?.count === 0)}
            >
                <div className="chart-wrapper">
                    <Chart type="pie" data={data} options={options} data-testid="chart"/>
                </div>
            </ChartInner>
        </div>
    );
};

export default LatencyDistributionChart;
